import { CarrierVerification } from 'types/CarrierVerification';
import { Maybe } from 'types/UtilityTypes';
import { useThrowableSWR } from 'utils/fetcher';

type CarrierVerificationByDotMcFetchResult = {
  carrier: Maybe<CarrierVerification>;
  isLoading: boolean;
  error: Maybe<Error>;
};

export default function useFetchCarrierVerificationByDotMc(
  dotNumber?: Maybe<string>,
  mcNumber?: Maybe<string>,
  enabled: boolean = true
): CarrierVerificationByDotMcFetchResult {
  // Only fetch if we have non-empty values
  const hasDotNumber = dotNumber && dotNumber.trim().length > 0;
  const hasMcNumber = mcNumber && mcNumber.trim().length > 0;
  const shouldFetch = enabled && (hasDotNumber || hasMcNumber);

  const queryParams = new URLSearchParams();
  if (hasDotNumber) {
    queryParams.append('dot_number', dotNumber!.trim());
  }
  if (hasMcNumber) {
    // Remove "MC" prefix if present, backend will normalize it
    const normalizedMc = mcNumber!.replace(/^MC/i, '').trim();
    queryParams.append('mc_number', normalizedMc);
  }

  const url =
    shouldFetch && queryParams.toString()
      ? `carrierverification/search?${queryParams.toString()}`
      : null;

  const res = useThrowableSWR<CarrierVerification>(url, false);

  return {
    carrier: res.data ? res.data : null,
    isLoading: shouldFetch ? res.isLoading : false,
    error: shouldFetch ? res.error : null,
  };
}
